module.exports = __webpack_public_path__ + "static/img/hr-tools-background.0158e89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hr-tools-background.png
// module id = 3lpX
// module chunks = 0